/** Mirrors backend user-availability constants for UI + filters. */

export const DAY_PRESET_VALUES = [
  "FULL_WEEK",
  "WEEKDAYS",
  "MWF",
  "TTS",
  "WEEKENDS",
  "CUSTOM",
];

export const CUSTOM_DAY_VALUES = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

export const SHIFT_DURATION_VALUES = ["8_HOURS", "12_HOURS", "NO_PREFERENCE"];

export const SHIFT_TYPE_VALUES = ["DAYTIME", "NIGHTTIME", "NO_PREFERENCE"];

export const DAY_PRESET_OPTIONS = [
  { value: "FULL_WEEK", label: "Full Week", hint: "Mon - Sun" },
  { value: "WEEKDAYS", label: "Weekdays (M-F)", hint: "Mon - Fri" },
  { value: "MWF", label: "Mon, Wed, Fri (MWF)", hint: "Mon, Wed, Fri" },
  { value: "TTS", label: "Tue, Thu, Sat (TTS)", hint: "Tue, Thu, Sat" },
  { value: "WEEKENDS", label: "Weekends (Sat, Sun)", hint: "Sat, Sun" },
  { value: "CUSTOM", label: "Custom Selection", hint: "Select specific days" },
];

export const CUSTOM_DAY_OPTIONS = [
  { value: "MON", label: "Mon" },
  { value: "TUE", label: "Tue" },
  { value: "WED", label: "Wed" },
  { value: "THU", label: "Thu" },
  { value: "FRI", label: "Fri" },
  { value: "SAT", label: "Sat" },
  { value: "SUN", label: "Sun" },
];

export const SHIFT_DURATION_OPTIONS = [
  { value: "8_HOURS", label: "8 Hours" },
  { value: "12_HOURS", label: "12 Hours" },
  { value: "NO_PREFERENCE", label: "No Preference" },
];

export const SHIFT_TYPE_OPTIONS = [
  { value: "DAYTIME", label: "Daytime Shift", hint: "7:00 AM - 7:00 PM" },
  { value: "NIGHTTIME", label: "Nighttime Shift", hint: "7:00 PM - 7:00 AM" },
  { value: "NO_PREFERENCE", label: "No Preference", hint: "" },
];

export const EMPTY_AVAILABILITY = {
  dayPresets: [],
  customDays: [],
  shiftDurations: [],
  shiftTypes: [],
};

export const formatAvailabilitySummary = (availability) => {
  if (!availability?.hasAvailability) {
    return { primary: "—", secondary: "", hasAvailability: false };
  }
  return {
    primary: availability.primary || "—",
    secondary: availability.secondary || "",
    hasAvailability: true,
  };
};

export const availabilityStatusDotClass = (availability) => {
  if (!availability?.hasAvailability) return "bg-slate-300";
  const secondary = String(availability.secondary || "").toLowerCase();
  if (secondary.includes("night")) return "bg-amber-400";
  return "bg-emerald-500";
};

export const toggleArrayValue = (list, value) => {
  const set = new Set(list || []);
  if (set.has(value)) set.delete(value);
  else set.add(value);
  return Array.from(set);
};
